import request from '../utils/user_request'
import RSAKey from './rsa.js'
import { Notification } from 'element-ui'

const RsaEncrypt = function (initPassword, callback) {
  request({
    url: 'encryption/getPublicKey',
    method: 'GET'
  }).then(response => {
    if (response.data.code === 0 && callback) {
      let rsa = new RSAKey()
      rsa.setPublicByBase64(response.data.data.modulus, response.data.data.exponent)
      let encryptPWD = rsa.encryptToBase64(initPassword, response.data.data.keysize)
      callback(encryptPWD)
    } else if (response.data.code === 1) {
      Notification.error({
        title: '未登录',
        message: '没有登录，或没有进行认证'
      })
    } else if (response.data.code === 2) {
      Notification.error({
        title: '数据验证失败',
        message: response.data.message
      })
      return Promise.reject(response)
    } else if (response.data.code === 3) {
      if (response.data.businessErrorKey === 'passwordTokenError') {
        sessionStorage.removeItem('loginName')
        sessionStorage.removeItem('passwordToken')
        this.$router.push({ path: '/login' })
      } else {
        Notification.error({
          title: '业务操作异常',
          message: response.data.message
        })
        return Promise.reject(response)
      }
    } else if (response.data.code === 4) {
      Notification.error({
        title: '没有操作权限',
        message: response.data.message
      })
      return Promise.reject(response)
    } else if (response.data.code === 5) {
      Notification.error({
        title: '数据操作异常',
        message: response.data.message
      })
      return Promise.reject(response)
    } else if (response.data.code === 6) {
      Notification.error({
        title: '显示层异常',
        message: response.data.message
      })
      return Promise.reject(response)
    } else if (response.data.code === 7) {
      Notification.error({
        title: '授权码非法',
        message: response.data.message
      })
      return Promise.reject(response)
    } else if (response.data.code === 127) {
      Notification.error({
        title: '系统错误！！！',
        message: response.data.message
      })
      return Promise.reject(response)
    } else {
      Notification.error({
        title: '错误1',
        message: response.data.message
      })
      return Promise.reject(response)
    }
  }).catch(() => {})
}

export default RsaEncrypt



// WEBPACK FOOTER //
// ./src/utils/RsaEncrypt.js